var showdown  = require('showdown')
export default class Converter{

    static getHtmlFromMarkDown(markdown){
        const  converter = new showdown.Converter();
        const html  = converter.makeHtml(markdown);
        return html
    }


}